import styled, { css } from 'styled-components'

import { Cores } from 'src/componentes/styles/cores'
import { FormUnform } from 'src/componentes/unform/form'

export const Pagina = styled.div`
  width: 100%;
  padding: 0 0 32px;
`

export const Intro = styled.div`
  margin: 8px 0 20px;
  max-width: 72ch;

  p {
    margin: 8px 0 0;
    color: ${Cores.CINZA_2};
    font-size: 15px;
    line-height: 1.5;
  }
`

export const Form = styled(FormUnform)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
`

export const Campo = styled.div<{ mr?: boolean }>`
  flex: 1;

  ${({ mr }) =>
    mr &&
    css`
      margin-right: 10px;
    `}
`

export const Dados = styled.div`
  margin-top: 25px;
  width: 100%;
`

export const TabelaBox = styled.div`
  width: 100%;
  overflow-x: auto;
  background: ${Cores.BRANCO};

  > div {
    width: 100%;
  }

  table {
    width: 100%;
  }
`

export const Pill = styled.span<{
  variacao?: 'ok' | 'warn' | 'erro' | 'neutro'
}>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  background: ${({ variacao }) =>
    variacao === 'ok'
      ? Cores.SUCESSO_FUNDO
      : variacao === 'erro'
      ? Cores.PERIGO_ERRO_FUNDO
      : variacao === 'warn'
      ? Cores.ATENCAO_FUNDO
      : '#efceff'};
  color: ${({ variacao }) =>
    variacao === 'ok'
      ? Cores.SUCESSO_ESCURO
      : variacao === 'erro'
      ? Cores.PERIGO_ERRO_ESCURO
      : variacao === 'warn'
      ? Cores.ATENCAO_ESCURO
      : '#4f2f7d'};
`

export const Acoes = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
`

export const IconeAcao = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;

  svg {
    height: 16px;
    width: auto;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`

export const Nota = styled.p`
  margin: 16px 0 0;
  color: ${Cores.CINZA_2};
  font-size: 13px;
`
